import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { IsTGRFreespinsTriggered } from "decisions/is-tgr-freespins-triggered";
import { ShouldTGRExitFreespins } from "decisions/should-tgr-exit-freespins";
import { PartnerConnectEndCommand } from "partner-connect/commands/partner-connect-end-command";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { WinCycle } from "slotworks/state-machine/standard/super-states/win-cycle";

export class TGRWinCycle extends WinCycle {

    public onEnter(): void {
        this.signalBindings.push(Services.bet.onBetChange.add(() => this.collapse()));
        this.signalBindings.push(Services.autoplay.onConfirm.add(() => this.collapse()));
        this.signalBindings.push(uiFlags.onFlagsUpdated.add(() => {
            if (uiFlags.has(UIMenuFlag.AUTO)) {
                this.collapse();
            }
        }));

        const gameplay = gameState.getCurrentGame();

        this.readyToExit = false;
        this.onReadyToExit = null;
        this.isFreeSpins = false;
        this.collapsed = false;

        const recordWin = gameplay.getCurrentRecord().cashWon;
        const totalWin = gameplay.getCurrentTotalWin();

        const record = gameplay.getCurrentRecord();
        let closeGame = true;

        if (record instanceof SpinRecord) {
            if (record.getFreespinsWon() > 0 || record.isBonusTriggered()) {
                closeGame = false;
            }
        }

        if (record instanceof FreespinRecord || new IsTGRFreespinsTriggered().evaluate() === Exit.True || new ShouldTGRExitFreespins().evaluate() === Exit.True) {
            this.isFreeSpins = true;
            closeGame = false;
        } else if (gameplay.isComplete()) {
            closeGame = true;
        }

        Services.transaction.setWinnings(recordWin, totalWin).execute();

        if (closeGame) {

            uiFlags.set(UIFlag.GAME_IN_PROGRESS, false);
            uiFlags.set(UIFlag.AWAITING_RESPONSE, true);

            this.closeGame().then(() => {

                if (!this.isFreeSpins) {
                    this.gameComplete();
                }

                uiFlags.set(UIFlag.AWAITING_RESPONSE, false);
                if (!Services.autoplay.isAutoPlaying()) {
                    uiFlags.set(UIFlag.IDLE, true);
                }

                this.readyToExit = true;

                if (this.onReadyToExit) {
                    this.onReadyToExit();
                }
            });
        } else {
            this.readyToExit = true;
        }
    }

    protected closeGame(): Contract<void> {
        return PartnerConnectEndCommand();
    }
}
